import script from "./CarouselMost.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselMost.vue?vue&type=script&setup=true&lang=js"

import "./CarouselMost.vue?vue&type=style&index=0&id=6e13a4a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e13a4a7"]])

export default __exports__